import React, { useEffect, useState } from 'react';
import { IDobbiesBuyboxProductDetailsConfig } from '../../dobbies-buybox-product-details.props.autogenerated';
import { _getScreenSize, cleanupScreenSizeListener } from '../../../../themes/dobbies/utilities/display-utils';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

interface IKeyFeaturesFloweringProps {
    floweringTime?: string;
    config: IDobbiesBuyboxProductDetailsConfig;
}
interface IFloweringData {
    type: string;
    legends: {
        [x: string]: string[];
    };
}

export default function KeyFeaturesFlowering(props: IKeyFeaturesFloweringProps) {
    const [screenSize, setScreenSize] = useState<number>(3);
    const [floweringData, setFloweringData] = useState<IFloweringData>();

    React.useEffect(() => {
        if (props.floweringTime && props.floweringTime !== '') {
            try {
                const data = JSON.parse(props.floweringTime);
                setFloweringData(data);
            } catch (error) {
                console.error(error);
            }
        }
    }, [props.floweringTime]);

    const seasonConfig = props.config.floweringTime?.find(item => item.seasonType === floweringData?.type);

    const getMonthColor = (month: string) => {
        if (!seasonConfig?.legends) {
            return;
        }

        for (let i = seasonConfig.legends.length - 1; i >= 0; i--) {
            const legend = seasonConfig.legends[i];

            // @ts-ignore
            const activeMonths: string[] = floweringData.legends?.[legend.title || ''] || [];

            if (activeMonths.includes(month)) {
                return legend.color;
            }
        }

        return;
    };

    useEffect(() => {
        const device = _getScreenSize();
        setScreenSize(device);

        return () => {
            cleanupScreenSizeListener();
        };
    }, []);

    if (!floweringData || !seasonConfig) {
        return null;
    }

    return (
        <div className='flowering-time'>
            <h3>{seasonConfig?.title}</h3>

            <div className='flowering-months'>
                {MONTHS.map(month => (
                    <span className='month' key={month} style={{ color: getMonthColor(month) }}>
                        {screenSize > 3 ? month : month.charAt(0)}
                    </span>
                ))}
            </div>

            <div className='color-bars'>
                {seasonConfig?.legends &&
                    seasonConfig.legends.map(legend => {
                        const activeMonths: string[] = floweringData.legends?.[legend.title || ''] || [];
                        return (
                            <div className='bar' key={legend.title}>
                                {MONTHS.map((month, idx) => {
                                    const isActive = activeMonths.includes(month);
                                    const prevActive = activeMonths.includes(MONTHS[idx - 1]);
                                    const nextActive = activeMonths.includes(MONTHS[idx + 1]);

                                    const isFirst = isActive && !prevActive;
                                    const isLast = isActive && !nextActive;

                                    return (
                                        <span
                                            key={month}
                                            aria-label={month}
                                            style={{
                                                backgroundColor: isActive ? legend.color : 'transparent',
                                                borderTopLeftRadius: isFirst ? '4px' : '0',
                                                borderBottomLeftRadius: isFirst ? '4px' : '0',
                                                borderTopRightRadius: isLast ? '4px' : '0',
                                                borderBottomRightRadius: isLast ? '4px' : '0'
                                            }}
                                        />
                                    );
                                })}
                            </div>
                        );
                    })}
            </div>
            <div className='legend'>
                {seasonConfig?.legends &&
                    seasonConfig.legends.map(legend => (
                        <div key={legend.title} className='legend-item'>
                            {legend.imageIcon?.src && <img src={legend.imageIcon.src} alt='' />}

                            <span>{legend.title}</span>
                        </div>
                    ))}
            </div>
        </div>
    );
}
